module.exports = __webpack_public_path__ + "static/media/ios.39a1648f.png";